import { useState } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { StablesQuotesSection, PageHeaderWithBack } from "../../../Components/Molecules";
import { useAuth } from "../../../Contexts/AuthContext";
import { useStablesMarketQuotes } from "../../../Hooks/useStablesMarketQuotes";
import { StablesBalanceCards } from "./StablesBalanceCards";
import { StablesHistoryPanel } from "./StablesHistoryPanel";
import { StablesOperationsPanel } from "./StablesOperationsPanel";
import { StablesOperationLimitBar } from "./StablesOperationLimitBar";
import { STABLES_HOME_PATH } from "./constants";
import { useStablesPageData } from "./useStablesPageData";
import { StablesLimitsProvider } from "../../../Contexts/StablesLimitsContext";
import { StablesWalletGate } from "./StablesWalletGate";

export const StablesOperationPage = ({
  operation,
  title,
  subTitle,
  historyType,
  historyTitle,
  showBalances = true,
}) => {
  const history = useHistory();
  const { hasPermission } = useAuth();
  const canOperate = hasPermission("stablesoperate");
  const [refreshToken, setRefreshToken] = useState(0);
  const {
    accountData,
    brlBalance,
    brlBalanceFormatted,
    loadingBalance,
    reload: reloadPageData,
  } = useStablesPageData();
  const marketQuoteState = useStablesMarketQuotes({
    carouselOnly: true,
    autoRefreshMs: 8000,
  });

  const handleOperationConfirmed = () => {
    setRefreshToken((token) => token + 1);
    reloadPageData?.();
  };

  if (!canOperate) {
    return <Redirect to={STABLES_HOME_PATH} />;
  }

  return (
    <div className="w-full">
      <StablesWalletGate>
        <StablesQuotesSection showViewAll={false} quoteState={marketQuoteState} />

        <PageHeaderWithBack
          title={title}
          subTitle={subTitle}
          onBack={() => history.push(STABLES_HOME_PATH)}
        />

        <StablesLimitsProvider>
          <StablesOperationLimitBar operation={operation} />

          {showBalances && (
            <StablesBalanceCards
              brlBalance={brlBalance}
              brlBalanceFormatted={brlBalanceFormatted}
              loadingBalance={loadingBalance}
              stablesOnly={operation === "swap"}
              showTotalBrl={operation === "swap"}
              refreshToken={refreshToken}
            />
          )}

          <StablesOperationsPanel
            operation={operation}
            brlBalance={brlBalance}
            brlBalanceFormatted={brlBalanceFormatted}
            loadingBalance={loadingBalance}
            accountData={accountData}
            marketQuotes={marketQuoteState.quotes}
            marketQuotesLoading={marketQuoteState.loading}
            onOperationConfirmed={handleOperationConfirmed}
          />
        </StablesLimitsProvider>

        <StablesHistoryPanel
          historyType={historyType}
          title={historyTitle}
          refreshToken={refreshToken}
        />
      </StablesWalletGate>
    </div>
  );
};
